import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { showAlertSnackBar } from 'utils/Global';

export const useShowLabelPrinterError = () => {
  return () =>
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'Make sure label printer is running and configured properly',
    );
};
